import { create } from 'zustand'

export interface KioskPrinterInfo {
  printingWaitTime: number
}

interface KioskPrintWaitState {
  printerInfo: KioskPrinterInfo | null
  setPrinterInfo: (info: KioskPrinterInfo) => void
  clearPrinterInfo: () => void
}

export const useKioskPrintWait = create<KioskPrintWaitState>(set => ({
  printerInfo: null,
  setPrinterInfo: (info: KioskPrinterInfo) => set({ printerInfo: info }),
  clearPrinterInfo: () => set({ printerInfo: null }),
}))
